import Container from "@mui/material/Container";

import MKBox from "components/MKBox";

import Sidemenu from "../Componets/sidemenu";
import { Grid } from "@mui/material";
import MKTypography from "components/MKTypography";
import TopMenu from "pages/Componets/topMenu";
import { useEffect, useState } from "react";
import ReportService from "services/ReportService";
import MKButton from "components/MKButton";
import { Link } from "react-router-dom";
// import Footer from "examples/Footers/Footer";
// import footerRoutes from "footer.routes";

import notracking from "assets/images/notracking.png";

function Presentation() {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    ReportService.getHistory().then((res) => {
      console.log("history", res);
      setHistory(res.data);
    });
  }, []);

  // const getTypeText = (type) => {
  //   let bgColor, color, text;
  //   switch (type.substring(0, 1)) {
  //     case "R":
  //       bgColor = "#EEE0FF";
  //       color = "#9747FF";
  //       text = "창조가";
  //       break;
  //     case "E":
  //       bgColor = "#E5FFE0";
  //       color = "#55D15A";
  //       text = "상담가";
  //       break;
  //     case "A":
  //       bgColor = "#FEE5E5";
  //       color = "#FB4D4D";
  //       text = "행동가";
  //       break;
  //     case "D":
  //       bgColor = "#DCF0FF";
  //       color = "#438CFA";
  //       text = "분석가";
  //       break;
  //   }

  //   return { bgColor, color, text };
  // };

  return (
    <>
      <TopMenu color="dark" />
      <MKBox
        width="100%"
        sx={{
          pt: 15,
          my: 0,
          backgroundColor: "#ffffff",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={12}
            spacing={3}
            display="flex"
            // flexDirection="column"
            alignItems="left"
            sx={{ textAlign: "left", my: 0, mx: "auto", px: 0.75 }}
          >
            <Grid item xs={12} lg={2} sx={{ mx: "auto" }}>
              <Sidemenu />
            </Grid>
            <Grid item xs={12} lg={10} sx={{ mx: "auto", minHeight: 900 }}>
              <MKTypography variant="h5">추적진단</MKTypography>
              <MKTypography variant="h6" mt={2}></MKTypography>
              <Grid container item xs={11} spacing={3} alignItems="left" sx={{ mx: "auto" }} mt={3}>
                {history.length === 0 && (
                  <>
                    <MKBox mx={"auto"} mt={8} justifyContent="center">
                      <MKBox mx={20}>
                        <MKBox component="img" src={notracking} width={80} />
                      </MKBox>
                      <MKTypography
                        variant="h6"
                        mt={2}
                        width={400}
                        sx={{ color: "#5A5A5A", fontSize: 14 }}
                        textAlign="center"
                      >
                        12개월 추적진달을 통해 보다 더 정확한 기질데이터를 분석하고 월별 회복탄력성
                        지수와 원인을 파악할 수 있습니다.
                      </MKTypography>
                      <MKBox mt={2} mx={15}>
                        <MKButton
                          variant="gradient"
                          color="dark"
                          style={{ color: "#03FF99" }}
                          fullWidth
                          component={Link}
                          to="/test"
                        >
                          추적 진단 시작하기
                        </MKButton>
                      </MKBox>
                    </MKBox>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Container>
        {/* <Footer content={footerRoutes} /> */}
      </MKBox>
    </>
  );
}

export default Presentation;
